import axios from './BaseService';

const FUTURES_URL = `${process.env.REACT_APP_API_URL}/futures-trader`;

export async function getActive() {
    const response = await axios.get(`${FUTURES_URL}/active`);
    return response.data;
}

export async function getHistory() {
    const response = await axios.get(`${FUTURES_URL}/history`);
    return response.data;
}

export async function getMinBudget(symbol) {
    const response = await axios.get(`${FUTURES_URL}/minbudget?symbol=${symbol}`);
    return response.data;
}

export async function getPresets() {
    const response = await axios.get(`${FUTURES_URL}/presets`);
    return response.data;
}

export async function getAccess() {
    const response = await axios.get(`${FUTURES_URL}/access`);
    return response.data;
}

export async function start(payload) {
    const response = await axios.post(`${FUTURES_URL}/start`, payload);
    return response.data;
}

export async function stop(id) {
    const response = await axios.post(`${FUTURES_URL}/stop/${id}`, {});
    return response.data;
}

export async function sellNow(id) {
    const response = await axios.post(`${FUTURES_URL}/sell-now/${id}`, {});
    return response.data;
}

// ----- System default templates (PAUSED) -----

export async function getTemplates() {
    const response = await axios.get(`${FUTURES_URL}/templates`);
    return response.data;
}

export async function updateTemplate(id, payload) {
    const response = await axios.patch(`${FUTURES_URL}/templates/${id}`, payload);
    return response.data;
}

export async function startTemplate(id, payload) {
    const response = await axios.post(`${FUTURES_URL}/templates/${id}/start`, payload || {});
    return response.data;
}

export async function pauseTemplate(id) {
    const response = await axios.post(`${FUTURES_URL}/templates/${id}/pause`, {});
    return response.data;
}
